<template>
	<div class="edit-company">
		<div class="edit-company-header">
			<h1 class="title-company">Compañia</h1>
		</div>
		<div class="edit-company-body">
			<div class="edit-company-body-section">
				<div class="company-body-logos">
					<h2 class="title-section">Logos</h2>
					<div>
						<upload-image 
							label-ref="upload-file"
							label-for="upload-file"
							:visible-more="false"
							text-label="Logo Principal"
							v-if="company.logoCompany"
							:url-image="company.logoCompany[0].url"
							@send-image="getImageLogoCompany"
						/>
						<upload-image 
							label-ref="upload-file-master"
							label-for="upload-file-master"
							:visible-more="false"
							text-label="Logo Secundario"
							v-if="company.logoMaster"
							:url-image="company.logoMaster[0].url"
							@send-image="getImageLogoMaster"
						/>
						<upload-image 
							label-ref="upload-file-mobile"
							label-for="upload-file-mobile"
							:visible-more="false"
							text-label="Logo Secundario Mobile"
							v-if="company.logoMaster"
							:url-image="company.logoMaster[1].url"
							@send-image="getImageLogoFooter"
						/>
					</div>
				</div>
				<div class="company-body-logos-footer">
					<h2 class="title-section">Footer</h2>
					<div>
						<div class="wrapper-input">
							<label 
								for="mail"
								class="label-modal">
								E-mail
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="mail"
								v-model="company.mailContact"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="name"
								class="label-modal">
								Télefono
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="name"
								v-model="company.numberContact"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="extension"
								class="label-modal">
								Extensión
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="extension"
								v-model="company.numberExtension"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="address"
								class="label-modal">
								Dirección
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="address"
								v-model="company.address"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="latitude"
								class="label-modal">
								Latitud 
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="latitude"
								v-model="company.latitude"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="length"
								class="label-modal">
								Longitud 
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="length"
								v-model="company.longitude"
							>
						</div>
					</div>
				</div>
				<div class="company-body--details">
					<h2 class="title-section">Detalles</h2>
					<div>
						<div class="wrapper-input">
							<!-- <label 
								for="mail"
								class="label-modal">
								Home/Video (Link de youtube, de preferencia que dure como máximo 10s)
							</label> -->
							<!-- <input 
								type="url"
								class="form-input-modal"
								id="mail"
								v-model="company.linkText"
							> -->
							<upload-image 
								label-ref="upload-file-video"
								label-for="upload-file-video"
								:visible-more="false"
								text-label="Home/Image"
								:url-image="company.linkText"
								@send-image="getImageHomeVideo"
							/>`
						</div>
					</div>
				</div>
				<div class="edit-company--section">
						<div class="edit-company--section--subtitle">
							<h3>Links</h3>
							<button
								class="btn btn-blue btn-small"
								@click.prevent="addLink">Agregar Link</button>
						</div>
						<div
							class="edit-company--section--row"
							v-for="(link, index) in company.linkUrl"
							:key="`link-${index}`">
							<label 
								for="protocol"
								class="label-modal">Link</label>
							<div class="row--form-control">
								<input
									class="row--form-input form-input-modal"
									v-model="link.text"
									placeholder="Texto"
									type="text" />
								<input
									class="row--form-input form-input-modal"
									v-model="link.order"
									placeholder="Orden"
									type="text" />
								<button
									@click.prevent="deleteLink(index)"
									class="btn btn-red btn-small">
									<simple-svg 
										class="social-icon"
										filepath="/static/img/icon-close.svg"
										:height="'20px'"
										:fill="'#fff'" />
								</button>
							</div>
							<div class="row--form-control">
								<input
									class="row--form-input form-input-modal form-input-modal--full"
									v-model="link.url"
									placeholder="Url"
									type="text" />
							</div>
						</div>
					</div>
			</div>
			<div class="edit-company-body-section">
				<div class="company-body-logos-social">
					<h2 class="title-section">Redes Sociales</h2>
					<div>
						<div class="wrapper-input">
							<label 
								for="name-social"
								class="label-modal">
								Nombre
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="name-social"
								v-model="newSocial.name"
							>
						</div>
						<upload-image 
							label-ref="upload-file-social"
							label-for="upload-file-social"
							:visible-more="false"
							text-label="Icono Red Social"
							:url-image="newSocial.icon"
							@send-image="getImageSocial"
						/>
						<div class="wrapper-input">
							<label 
								for="link"
								class="label-modal">
								Link de red social
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="link"
								v-model="newSocial.link"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="width"
								class="label-modal">
								Tamaño
							</label>
							<input 
								type="number"
								class="form-input-modal"
								v-model="newSocial.width"
							>
						</div>
						<button 
							class="btn-edit btn-block btn-back"
							:class="{'disable-class': disabledAdd}"
							@click="addSocial"
							:disabled="disabledAdd">{{title}} Red Social</button>
						<div class="wrapper-list-social">
							<div
								v-for="(item, index) in company.socialMedia" 
								:key="index"	
								class="list-social">
								<span>{{item.name}}</span>
								<div>
									<button @click="editSocial(item)">
										<img 
											src="/static/img/icon-edit-dark.svg" 
											alt="editar"
											height="20px">
									</button>
									<button @click="deleteSocial(index)">
										<img 
											src="/static/img/icon-close-dark.svg" 
											alt="eliminar"
											height="20px">
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<h2 class="title-section">Configuración Simple Mail Transfer Protocol(SMTP)</h2>
					<div>
						<div
							v-if="company.credentialsMail"
							class="wrapper-input">
							<label 
								for="host"
								class="label-modal">
								Host
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="host"
								v-model="company.credentialsMail.host"
							>
						</div>
						<div
							v-if="company.credentialsMail"
							class="wrapper-input">
							<label 
								for="port"
								class="label-modal">
								Puerto
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="port"
								v-model="company.credentialsMail.port"
							>
						</div>
						<div
							v-if="company.credentialsMail"
							class="wrapper-input">
							<label 
								for="user-company"
								class="label-modal">
								Usuario
							</label>
							<input 
								type="text"
								class="form-input-modal"
								id="user-company"
								v-model="company.credentialsMail.user"
							>
						</div>
						<div class="wrapper-input">
							<label 
								for="password-company"
								class="label-modal">
								Contraseña
							</label>
							<input 
								type="password"
								class="form-input-modal"
								id="password-company"
								v-model="serverPassword"
							>
						</div>
						<div
							v-if="company.credentialsMail"
							class="wrapper-input">
							<label 
								for="protocol"
								class="label-modal">
								Protocolo de Encriptacion
							</label>
							<select
								name="category"
								id="protocol"
								class="form-input-modal"
								v-model="company.credentialsMail.ssl"
							>
								<option 
									v-for="(protocol, index) in protocols"
									:key="index"
									:value="protocol.value">{{protocol.name}}</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="wrapper-btn">
			<button 
				class="btn-edit btn-back"
				@click="goToBack">Átras</button>
			<button 
				class="btn-edit btn-back"
				@click="saveEditCompany">Guardar</button>
		</div>
	</div>
</template>
<script>
import orderBy from 'lodash/orderBy';
import uploadImage from '@/components/commons/upload-image';
import helper from '@/shared/helper';

const methods = {
	addLink() {
		this.company.linkUrl.unshift({
			text: '',
			url: '',
			order: 0,
		});
	},
	deleteLink(i) {
		this.company.linkUrl.splice(i, 1);
	},
	getImageHomeVideo(url) {
		this.company.linkText = url;
	},
};

function data() {
	return {
		company: {},
		newSocial: {
			icon: '',
			link: '',
			name: '',
			width: '',
		},
		serverPassword: '',
		protocols: [
			{ name: 'ssl', value: true },
			{ name: 'tls', value: false },
		],
		flagEdit: false,
		title: 'Agregar',
	};
}

function created() {
	const login = helper.getLocalData('flag-admin');
	if (login) {
		this.loadCompany();
	} else {
		this.showError('Iniciar Sesión');
		this.goTo('page-login');
	}
}

async function loadCompany() {
	try {
		const { data: response } = await this.$http.get(`company/${process.env.COMPANY_CODE}/app/${process.env.APP_CODE}`);
		this.company = { ...response.data };
		this.company.linkUrl = orderBy(this.company.linkUrl, 'order');
	} catch (error) {
		this.showError();
	}
}

function getImageLogoCompany(url) {
	this.company.logoCompany[0].url = url;
}

function getImageLogoMaster(url) {
	this.company.logoMaster[0].url = url;
}

function getImageLogoFooter(url) {
	this.company.logoMaster[1].url = url;
}

function getImageSocial(url) {
	this.newSocial.icon = url;
}

function addSocial() {
	if (!this.flagEdit) {
		this.company.socialMedia.push(this.newSocial);
	}
	this.newSocial = {
		icon: '',
		link: '',
		name: '',
		width: '',
	};
	this.flagEdit = false;
	this.title = 'Agregar';
}

function disabledAdd() {
	return !(this.newSocial.icon);
}

function editSocial(social) {
	this.flagEdit = true;
	this.newSocial = social;
	this.title = 'Editar';
}

function deleteSocial(index) {
	if (index > -1) {
		this.company.socialMedia.splice(index, 1);
	}
}

async function saveEditCompany() {
	this.company.linkText = [this.company.linkText];
	this.company.location = {
		latitude: this.company.latitude,
		longitude: this.company.longitude,
	};
	this.company.credentialsMail.password = this.serverPassword;
	this.company.imageFooter = '';
	try {
		await this.$http.put(`edit/companies/${process.env.APP_CODE}`, this.company);
		this.showNotification('Se actualizó correctamente');
		this.goTo('page-home');
	} catch (error) {
		if (error.data.latitude) {
			this.showError('Ingresar latitud válida');
		} else if (error.data.longitude) {
			this.showError('Ingresar longitud válida');
		} else if (error.data.mailContact) {
			this.showError('Email es requerido');
		} else {
			this.showError();
		}
	}
}

function goToBack() {
	this.goTo('page-home');
}

export default {
	name: 'edit-company',
	data,
	components: {
		uploadImage,
	},
	methods: {
		...methods,
		loadCompany,
		getImageLogoCompany,
		getImageLogoMaster,
		getImageLogoFooter,
		getImageSocial,
		addSocial,
		editSocial,
		deleteSocial,
		saveEditCompany,
		goToBack,
	},
	computed: {
		disabledAdd,
	},
	created,
};
</script>

<style lang="scss" scoped>
.edit-company {
	&--section {
		&--subtitle {
			@include display-flex();
			justify-content: space-between;

			h3 {
				@include font-size(20);
				@include font-maison-bold();
				color: map-get($colors, borde-input);
				margin: 20px 0;
			}
		}

		&--row {
			@include display-flex();
			flex-direction: column;
		}
	}
	
	.row {
		&--form-control {
			@include display-flex();
			align-items: center;
			
			& + .row--form-control {
				margin-top: 10px;

				.row--form-input {
					margin-right: 0;
				}
			}

			> input {
				flex: 1;
			}

			.btn {
				@include display-flex();
				align-items: center;
				line-height: normal;
				padding: 0 10px;
			}

			.btn-red {
				background-color: #f52c18;
			}

			.form-input-modal {
				margin-bottom: 0;
			}
		}


		&--form-input {
			margin-right: 10px;
		}
	}
}

	.label-modal {
		@include font-size(12);
	}

	.form-input-modal {
		@include border-radius(5px);
		border: 1px solid map-get($colors, gray-text);
		height: 47px;
		margin-bottom: 10px;
	}

	.edit-company {
		padding: 80px 100px;
		position: relative;
	}

	.edit-company-body {
		@include display-flex();
		justify-content: space-between;
	}

	.edit-company-body-section {
		width: 45%;
	}

	.btn-edit {
		color: map-get($colors, white);
		height: 45px;
		margin: 10px;
		width: 187px;
	}

	.btn-back {
		background-color: map-get($colors, black-dark); 
	}

	.list-social {
		@include border-radius(10px);
		@include display-flex();
		border: 1px solid map-get($colors, borde-input);
		height: 60px;
		justify-content: space-between;
		margin-bottom: 10px;
		padding: 18px;
		width: 100%;
	}

	.title-company {
		@include font-size(24);
		@include font-maison-bold();
		border-bottom: 1px solid map-get($colors, borde-input);
		color: map-get($colors, borde-input);
		margin-bottom: 50px;
		padding-bottom: 18px;
	}

	.title-section {
		@include font-size(20);
		@include font-maison-bold();
		color: map-get($colors, borde-input);
		margin: 20px 0;
	}

	.wrapper-btn {
		@include display-flex();
		justify-content: center;
		margin-top: 85px;
	}

	.btn-block {
		display: block;
		margin: 10px auto;
	}

	.wrapper-list-social {
		border-top: 1px solid map-get($colors, borde-input);
		padding-top: 22px;
	}

	.disable-class {
		cursor: not-allowed;
		opacity: 0.25;
	}

	.wrapper-input {
		@include display-flex();
		flex-direction: column;
	}

	

</style>


// WEBPACK FOOTER //
// src/pages/page-admin-company.vue